import { useFormContext } from "react-hook-form";
import { FormattedMessage, FormattedNumber } from "react-intl";

import {
  SelectContent,
  SelectField,
  SelectItem,
} from "@/components/atoms/Select";
import { Text } from "@/components/atoms/Text";
import { ListingData } from "~/context/ListingPageDataContext";

type AttendeeSelectFieldProps = {
  listingAttendeePricing: ListingData["listingAttendeePricing"];
  currency: string;
};

export const AttendeeSelectField = ({
  listingAttendeePricing,
  currency,
}: AttendeeSelectFieldProps) => {
  const { watch } = useFormContext();

  return (
    <SelectField
      labelDataTestingId="selectedAttendeeRangeLabel"
      buttonDataTestingId="attendeesDropdownButton"
      name="attendeePricingTierMax"
      value={String(watch("attendeePricingTierMax"))}
      label={<FormattedMessage defaultMessage="Attendees" />}
      triggerClassName="[&>span:first-child]:tw-w-full"
      fullWidth
      testId="book-listing-attendee-select-field"
      renderContent={() => (
        <SelectContent>
          <span data-testing-id="attendeesDropdownMenu">
            {listingAttendeePricing.tiers.map((option) => (
              <SelectItem
                className="[&>span:first-child]:tw-w-full"
                key={option.value}
                value={option.max.toString()}
              >
                <div className="tw-flex tw-justify-between">
                  <Text>
                    <FormattedMessage
                      defaultMessage="{min} - {max} people"
                      values={{
                        min: option.min,
                        max: option.max,
                      }}
                    />
                  </Text>
                  <Text className="tw-text-gray-600">
                    <FormattedMessage
                      defaultMessage="+{prices}/hr"
                      values={{
                        prices: (
                          <FormattedNumber
                            value={option.value}
                            currency={currency}
                            style="currency"
                            minimumFractionDigits={
                              0 === option.value % 1 ? 0 : 2
                            }
                            maximumFractionDigits={
                              0 === option.value % 1 ? 0 : 2
                            }
                          />
                        ),
                      }}
                    />
                  </Text>
                </div>
              </SelectItem>
            ))}
          </span>
        </SelectContent>
      )}
    />
  );
};
